<template>
  <div class="container-commission">
    <div class="commission-config-right">
      <!-- 组织机构 -->
      <div class="wrapper">
        <div class="main-panel">
          <div class="search-box">
            <div class="input-item">
              <span class="label">保险公司</span>
              <Select v-model="searchParams.companyIds" multiple clearable filterable>
                <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
              </Select>
            </div>
            <div class="input-item">
              <span class="label">保险产品</span>
              <Select v-model="searchParams.id" clearable filterable>
                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </div>
            <div class="input-item">
              <span class="label">产品分类</span>
              <Select v-model="searchParams.productTypes" multiple clearable filterable>
                <Option v-for="(txt, value) in themeList" :value="value" :key="value">{{ txt }}</Option>
              </Select>
            </div>
            <div class="input-item">
              <span class="label">产品状态</span>
              <Select v-model="searchParams.productStatus" clearable>
                <Option v-for="item in productStatusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
            <div class="btn-item">
              <Button type="primary" @click="searchAjax()">查询</Button>
              <Button type="primary" ghost @click="back()">返回</Button>
            </div>
          </div>
          <!-- 表格 -->
          <div class="table-box">
            <loading :isShow="listLoading" />
            <Table ref="table" :columns="columns" :data="tableData" border>
              <template slot-scope="{ row }" slot="action">
                <span v-if="row.id" class="table-btn" @click="$refs.productBatchCommissionsRef.open(row)">查看</span>
              </template>
            </Table>
            <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
          </div>
        </div>
      </div>
    </div>

    <productBatchCommissions @success="searchAjax()" ref="productBatchCommissionsRef"></productBatchCommissions>
  </div>
</template>

<script>
import productBatchCommissions from './components/productBatchCommissions';
import { pageTool, common } from '@/api/mixins';
export default {
  name: 'feeConfig',
  components: {
    productBatchCommissions
  },
  mixins: [pageTool, common],
  data() {
    return {
      productStatusList: [
        { value: '0', label: '在售' },
        { value: '1', label: '停售' }
      ],
      themeList: JSON.parse(localStorage.dic)['PRODUCT_TYPE2'], // 产品类型
      productList: [], // 产品列表
      companyList: [], //保司列表
      searchParams: {
        companyIds: [],
        productTypes: []
      },
      columns: [],
    };
  },

  mounted() {
  },
  async activated() {
    let _this = this;
    this.searchParams.tenantId = this.$route.query.tenantId
    const columns = [
      {
        title: '产品名称',
        key: 'productName',
        align: 'center',
        minWidth: 220
      },
      {
        title: '保险公司',
        key: 'companyName',
        align: 'center',
        minWidth: 180
      },
      {
        title: '产品分类',
        key: 'productType',
        align: 'center',
        render(h, { row }) {
          return <span>{_this.themeList[row.productType]}</span>;
        },
        width: 120
      },
      {
        title: '产品状态', //0在售 1停售
        key: 'productStatus',
        align: 'center',
        width: 120,
        render(h, { row }) {
          if (row.productStatus == 1) {
            return (
              <Tag checkable color="error">
                停售
              </Tag>
            );
          } else if (row.productStatus == 0) {
            return (
              <Tag checkable color="success">
                在售
              </Tag>
            );
          }
        }
      },
      {
        title: '积分生成方式',
        key: 'id为空显示',
        align: 'center',
        minWidth: 180,
        render(h, params) {
          // id为空显示-，不为空显示按单独配置生成
          return <span>{params.row.id ? "按单独配置生成" : "-"}</span>;
        }
      },
      {
        title: '配置规则',
        key: 'configType',
        align: 'center',
        minWidth: 180,
        render(h, params) {
          let commissionConfigTypeMap = {
            '0': '统一留比例',
            '1': '按缴费期留比例',
            '2': '按缴费期留点'
          }
          return <span>{commissionConfigTypeMap[params.row.configType]}</span>;
        }
      },
      {
        title: '更新时间',
        key: 'updateTime',
        align: 'center',
        minWidth: 180
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 90,
        fixed: 'right'
      }];
    this.columns = columns;
    this.queryCompanyList();
    this.queryProductList();
    this.initListAjax('/buz/merchantProductCommissionConfig/read/list');
  },

  methods: {
    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 查询所有产品
    async queryProductList() {
      try {
        const res = await this.$http({
          url: '/buz/product/query/list',
          type: 'GET',
          data: {}
        });
        this.productList = Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        this.$notice.error('获取产品列表失败');
        this.productList = [];
      }
    },

    // 产品详情
    openDetailModal(row) {
      let { productId, tenantId, vipLevel, companyName, productName, code } = row;
      this.$router.push({
        path: '/operate/productManage/orgFee/rateDetail',
        query: {
          productId, tenantId, vipLevel, companyName, productName, code
        }
      });
    },


  }
};
</script>
<style lang="scss" scoped>
@import './productCommission.scss';
</style>
